/*=========================================================================================
  File Name: moduleMapActions.js
  Description: Map Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import IndexedDB from "@/helpers/IndexedDB.js";
export default {
	async saveMatchFilterOnIndexedDB({commit, state, dispatch}) {
		return new Promise((resolve, reject) => {
			(async () => {
				try {
					const matchFilter = await dispatch("getMatchFilter");
					if (matchFilter) {
						commit("UPDATE_MATCH_FILTER", {...state, ...matchFilter});
						dispatch("updateMatchFilter", {...state, ...matchFilter});
						resolve(matchFilter);
					} else {
						const userInfo = JSON.parse(localStorage.getItem("userInfo"));
						await IndexedDB.saveMatchFilter("match_filter", state, userInfo.uid);
						commit("UPDATE_MATCH_FILTER", state);
						resolve(state);
					}
				} catch (error) {
					console.error(error);
					reject(error);
				}
			})();
		});
	},
	updateMatchFilter({commit, state}, payload) {
		return new Promise((resolve, reject) => {
			(async () => {
				try {
					const userInfo = JSON.parse(localStorage.getItem("userInfo"));
					await IndexedDB.updateMatchFilter("match_filter", payload, userInfo.uid);
					commit("UPDATE_MATCH_FILTER", payload);
					resolve(payload);
				} catch (error) {
					reject(error);
				}
			})();
		});
	},
	getMatchFilter(state) {
		const userInfo = JSON.parse(localStorage.getItem("userInfo"));
		return IndexedDB.getKey("match_filter", userInfo.uid);
	},
	getAllMatchFilter() {
		return IndexedDB.getAll("match_filter");
	},
};
